module.exports = __webpack_public_path__ + "static/media/chuva.619e6a81.png";